import { Skeleton } from '@repo/ui'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { DeviceForm } from '@/features/admin/devices/components/device-form'
import { useAdminDevice } from '@/features/admin/devices/hooks/use-admin-devices'
import { useUpdateAdminDevice } from '@/features/admin/devices/hooks/use-update-admin-device'
import { AdminPageHeader } from '@/features/admin/layout/admin-page-header'
import { router } from '@/router'

export const Route = createFileRoute('/admin/devices/$deviceId/edit')({
  component: AdminDeviceEditPage,
})

function AdminDeviceEditPage() {
  const { t } = useTranslation('admin')
  const { deviceId } = Route.useParams()
  const id = Number(deviceId)

  const { data: device, isPending } = useAdminDevice(id)
  const { mutate, isPending: isSubmitting } = useUpdateAdminDevice(id)

  return (
    <div className="space-y-4">
      <AdminPageHeader
        title={t('devices.edit.title')}
        subtitle={device?.name || device?.deviceIdent}
      />
      <div className="mx-auto max-w-3xl">
        {isPending || !device ? (
          <Skeleton className="h-96 w-full rounded-md" />
        ) : (
          <DeviceForm
            defaultValues={{
              deviceIdent: device.deviceIdent,
              name: device.name ?? '',
              organizationId: device.organizationId ?? undefined,
              vehicleId: device.vehicleId ?? undefined,
            }}
            hideDeviceIdent
            isSubmitting={isSubmitting}
            onSubmit={(values) => {
              const { deviceIdent: _ignored, ...rest } = values
              mutate(rest)
            }}
            onCancel={() => router.navigate({ to: '/admin/devices' })}
            submitLabel={t('devices.edit.submit')}
          />
        )}
      </div>
    </div>
  )
}
